<template>
<div>
  <el-dialog
    :title="'导入交货单信息'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="100px" label-position="left">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="子公司" prop="subcompanyId">
            <el-select
                v-model="dataForm.subcompanyId"
                placeholder="请选择子公司"
                clearable
                @change="handleSubcompanyChange"              style="width: 100%">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 供应商代码 -->
        <el-col :span="12">
          <el-form-item label="供应商代码" prop="supplierCode">
            <el-input v-model="dataForm.supplierCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <!-- 供应商名称 -->
        <el-col :span="12">
          <el-form-item label="供应商名称" prop="supplierCode">
            <el-select          style="width: 100%"
                                v-model="dataForm.supplierCode"
                                filterable
                                placeholder="请选择供应商"
                                :disabled="!dataForm.subcompanyId"
                                @change="handleSupplierChange">
              <el-option
                  v-for="item in supplierList"
                  :key="item.supplierCode"
                  :label="item.supplierName"
                  :value="item.supplierCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <!-- 采购组代码 -->
        <el-col :span="12">
          <el-form-item label="采购组代码" prop="groupCode">
            <el-input v-model="dataForm.groupCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <!-- 采购组 -->
        <el-col :span="12">
          <el-form-item label="采购组" prop="groupCode">
            <el-select          style="width: 100%"
                                v-model="dataForm.groupCode"
                                filterable
                                placeholder="请选择采购组"
                                :disabled="!dataForm.subcompanyId || !dataForm.supplierCode"
                                @change="handleGroupChange">
              <el-option
                  v-for="item in this.groupList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--      <el-form-item label="采购组代码" prop="groupCode">-->
<!--        <el-input v-model="dataForm.groupCode" placeholder="采购组代码" :disabled="true"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="采购组" prop="groupName">-->
<!--        <el-select style="width: 220px" v-model="dataForm.groupCode" filterable placeholder="请选择采购组"  @change="handleGroupChange">-->
<!--          <el-option v-for="item in groupList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <!-- <el-form-item label="模板代码" prop="businesscode">
      <el-input v-model="dataForm.businesscode" placeholder="模板代码"></el-input>
    </el-form-item>
    <el-form-item label="模板名称" prop="name">
      <el-input v-model="dataForm.name" placeholder="模板名称"></el-input>
    </el-form-item> -->
      <el-form-item label="导入模板" prop="name">
          <el-upload
                  ref="upload"
                  :auto-upload="false"
                  drag
                  action
                  :http-request="upload"
                  :limit="1"
                  multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div cla3ss="el-upload__tip" slot="tip">只能上传xls文件，且不超过500kb</div>
          </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="exportTemplate()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;导出模板
      </el-button>
      <el-button @click="visible = false" :disabled="uploadLoading">
        <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
      </el-button>
      <el-button type="primary" @click="dataFormSubmit()" :disabled="uploadLoading">
        <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
      </el-button>
    </span>
  </el-dialog>

  <!--导入失败提示信息-->
  <el-dialog
          :title="'导入失败'"
          :close-on-click-modal="false"
          :visible.sync="deliveryTemplateImportErrortipVisible" class="error-dialog">

      <p v-for="error in errorTips" style="line-height: 25px;">{{ error }}</p>

      <span slot="footer" class="dialog-footer">
        <el-button @click="deliveryTemplateImportErrortipVisible = false">
          <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;关闭
        </el-button>
      </span>
  </el-dialog>

</div>
</template>

<script>
import {
  exportTemplate,
  importAsn
} from '@/controller/delivery'
import {getGroupListBySupplierCode,getGroupList} from '@/controller/order'
import {supCompanyList} from "../../../../controller/sys";
import {
  getAddressList,
  getSupplierList
} from '@/controller/delivery'
  export default {
    data () {
      return {
        uploadLoading: false,
        initValue: {
          tenantlist: []
        },
        supCompanyList: [],
        groupList: [],
        visible: false,
        deliveryTemplateImportErrortipVisible: false,
        errorTips: [],
        supplierList: [],
        dataForm: {
          subcompanyId: '',
          tenant: '',
          supplierName:'',
          supplierCode:'',
          groupCode:'',
          groupName:'',
        }
      }
    },
    methods: {
      init () {
        this.visible = true
        this.getSupCompanyList();
        this.dataForm.supplierCode = '';
        this.dataForm.supplierName = '';
        this.dataForm.groupCode = '';
        this.dataForm.groupName = '';
      },
      getAddressListByCode() {
        this.groupList = [];
        this.dataForm.groupCode = '';
        this.dataForm.groupName = '';
        this.getGroupList();
      },
      getGroupList() {
        getGroupList({ supplierCode: this.dataForm.supplierCode,
          subcompanyId: this.dataForm.subcompanyId}).then((data) => {
          if (data && data.code == '00') {
            // 强制转换 value 为 string，保证和 el-select 的值一致
            this.groupList = data.body.map(item => ({
              ...item,
              value: String(item.value)
            }));
            console.log('groupList是什么',this.groupList)
          }
        });
      },
      // 获取子公司列表
      getSupCompanyList() {
        supCompanyList().then(res => {
          if (res && res.code == '00') {
            this.supCompanyList = res.body;
          }
        })
      },
      // 子公司变更处理
      handleSubcompanyChange(val) {
        // 清空关联字段
        this.dataForm.supplierCode = '';
        this.dataForm.supplierName = '';
        this.dataForm.groupCode = '';
        this.dataForm.groupName = '';

        // 获取供应商列表
        this.getSupplierList();
      },
      handleSupplierChange(value) {
        const selectedSupplier = this.supplierList.find(item => item.supplierCode === value);
        if (selectedSupplier) {
          this.dataForm.supplierName = selectedSupplier.supplierName;
        }
        this.getAddressListByCode();
      },
      getSupplierList() {
        getSupplierList({subcompanyId: this.dataForm.subcompanyId }).then(data => {
          if (data && data.code === '00') {
            this.supplierList = data.body.body
          }
        })
      },
      getStyle() {
        return 'width: 110px; text-align: right'
      },
      getStyle2() {
        return 'width: 640.5px;'
      },
      handleGroupChange(value) {
        const selectedGroup = this.groupList.find(item => item.value === value)
        if (selectedGroup) {
          this.dataForm.groupName = selectedGroup.label
        }
      },
      // 导出模板
      exportTemplate() {
          exportTemplate().then((data) => {
                this.readAsBinaryString(data.body)
          }).catch((e) => {
              console.log(e)
          })
          // this.readAsBinaryString()
      },
      upload(obj) {
           let formData = new FormData()
            formData.set('file', obj.file)
            formData.set('groupCode', this.dataForm.groupCode)
            formData.set('groupName', this.dataForm.groupName)

            // 根据选中的子公司ID获取orgCode
            if (this.dataForm.subcompanyId) {
              const selectedCompany = this.supCompanyList.find(
                  item => item.id === this.dataForm.subcompanyId
              );
              if (selectedCompany) {
                formData.set('bukrs', selectedCompany.orgCode);
              }
            }
           importAsn(formData).then((data) => {
              this.$refs.upload.clearFiles()
              if(data.code === '00'){
                  this.$message.success({
                      message: '导入成功',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                          this.visible = false
                          this.$emit("refreshDataList")
                      }
                  })
              } else {
                 // this.$message.error(data.msg);
                  this.visible = false
                  this.errorTips = data.msg.split("##");
                  this.deliveryTemplateImportErrortipVisible = true;
              }
           }).catch((e) => {
             this.visible = false
             this.$message.error(e);
           }).finally(() => {
             this.uploadLoading = false;  // 无论成功或失败都结束加载状态
           })
      },
      readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
      },
      str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
      },
      // 表单提交
      dataFormSubmit() {
          this.$refs['dataForm'].validate((valid) => {
              if (valid) {
                  this.$refs.upload.submit();
              }
          })
      }
    }
  }
</script>

<style lang="scss">
.error-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(70vh - 140px);
}
</style>